import { render, staticRenderFns } from "./AttachmentSelector.vue?vue&type=template&id=35c14971&"
import script from "./AttachmentSelector.vue?vue&type=script&lang=ts&"
export * from "./AttachmentSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Agent-002\\_work\\9\\s\\Source\\FastFailureFeedback\\FastFailureFeedback.Web.MachineRegistration\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35c14971')) {
      api.createRecord('35c14971', component.options)
    } else {
      api.reload('35c14971', component.options)
    }
    module.hot.accept("./AttachmentSelector.vue?vue&type=template&id=35c14971&", function () {
      api.rerender('35c14971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "TypeScriptApps/Common/components/AttachmentSelector.vue"
export default component.exports